export default __webpack_public_path__ + "static/media/hare-krishna-flute-5200.36300e77.ogg";